import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import ROLFWebsite from './ROLFWebsite';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ROLFWebsite />
    </BrowserRouter>
  </React.StrictMode>
);
